import { CurrentPageService } from "@dandelion/core";
import { nextTick } from "vue";

export class CurrentPageServiceForTree extends CurrentPageService {

    public async scrollToVariable(fullNameForID: string, e?: Event) {
        e?.stopPropagation();

        if (!this.get(fullNameForID)) {
            this.set(fullNameForID);
        }

        await nextTick();

        const element = document.getElementById(fullNameForID) as HTMLElement;
        if (!element) {
            if (this.coreConfiguration.debug) {
                this.logger.logError(`Elemento con ID ${fullNameForID} non trovato`);
            }
            return;
        }

        // Estraiamo il prefisso dinamico e la categoria
        const match = fullNameForID.match(/^([^.]*)\.([^.]*)/);
        const prefix = match ? match[1] : null;
        const category = match ? match[2] : null;

        if (!category) {
            if (this.coreConfiguration.debug) {
                this.logger.logError(`Impossibile estrarre la categoria da ${fullNameForID}`);
            }
            return;
        }

        const menuElement = document.querySelector(`[id^='tree-component-content'] ul > li.${category}`) as HTMLElement;

        const height = window.innerHeight;
        const width = window.innerWidth;

        const vh = height * 0.01;
        const vw = width * 0.01;

        try {
            window.scrollTo({
                top: element.offsetTop - this.coreConfiguration.marginForScroll![0] * vh,
                left: element.offsetLeft - this.coreConfiguration.marginForScroll![1] + vw,
                behavior: 'smooth',
            });

            if (menuElement) {
                menuElement.scrollIntoView({ behavior: 'smooth',block: 'center'  });
            } else if (this.coreConfiguration.debug) {
                this.logger.logError(`Elemento menu corrispondente a ${category} non trovato`);
            }

        } catch {
            if (this.coreConfiguration.debug) {
                this.logger.logError(`Scrolling fallito per ${fullNameForID}`);
            }
        }
    }
}